import { i18n } from "translate/i18n";

export const confirmingAccount = i18n.t(
  "messages.authentication.confirmingAccount"
);
